module.exports = __webpack_public_path__ + "img/proceso_embotellado.0aa8d787.png";